'use strict';
const { validateDate } = require('./domUtil');

$(document).ready(function () {
    validateDate();
});
